import { FaArrowLeft, FaUserCircle } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiLogoutCircleRLine, RiChatHistoryLine } from "react-icons/ri";
import { BiCapsule } from "react-icons/bi";
import languageContext from "../context/language/languageContext";
import { useContext } from "react";
import { FaChild } from "react-icons/fa6";

const Navbar = () => {
  const {
    setChats,
    setbookappointment,
    checklist,
    setchecklist,
    bookappointment,
    setIsLeftPanel,
    isLeftPanel,
    labbook,
    labsetbook,
    sessionTimeout,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);

  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("login");
    navigate("/");
  };

  const handleBackArrowPress = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate("/insurance-dashboard");
  };

  const handleProfile = () => {
    navigate("/account");
  };

  const handleMedicineInfo = () => {
    navigate("/medicine_chat");
  };

  // const handleChildDetails = () => {
  //   navigate("/student-details"); // ✅ Replace route accordingly
  // };

  return (
    <div className="bg-white w-full h-[80px] flex items-center justify-between shadow-md px-4 border-b border-gray-100">
      <div className="flex items-center">
        <div
          className="w-[40px] h-[40px] bg-gray-100 rounded-full flex justify-center items-center ml-2 cursor-pointer hover:bg-gray-200 transition"
          onClick={handleBackArrowPress}
        >
          <FaArrowLeft />
        </div>

        {/* {!location.pathname.includes("/medicine_chat") && (
          <div
            className="w-[40px] h-[40px] bg-gray-100 rounded-full flex justify-center items-center ml-2 cursor-pointer hover:bg-gray-200 transition"
            onClick={() => {
              setIsRightPanel(false);
              setIsLeftPanel(!isLeftPanel);
            }}
          >
            <RiChatHistoryLine />
          </div>
        )} */}
      </div>

      <div className="flex items-center gap-2">
        {(location.pathname.includes("/account") ||
        location.pathname.includes("/patient_appointments")||
        location.pathname.includes("/patient_lab_tests")||
        location.pathname.includes("/patient_medicines")||
        location.pathname.includes("/adherence_report")||
        
        
        
          location.pathname.includes("/warden-dashboard") ||
          location.pathname.includes("/medicine_chat") ||
          location.pathname.includes("/student-details") ||
          location.pathname.includes("/view_lab_test") ||
          location.pathname.includes("/view_appointment") ||
          location.pathname.includes("/view_reminder") ||
          location.pathname.includes("/chat_summary") ||
          location.pathname.includes("/prescription_history") ||
          location.pathname.includes("/view_leave_alerts")||
          location.pathname.includes("/chat_history")) && (
            <>
              {!location.pathname.includes("/insurance-dashboard") &&
                <button
                  onClick={handleHome}
                  className="bg-emerald-50 hover:bg-emerald-100 text-emerald-800 rounded-lg px-4 py-2 flex items-center gap-2 font-medium shadow-sm transition"
                >
                  Home
                </button>

              }


              {/* <button
              onClick={handleProfile}
              className="bg-blue-50 hover:bg-blue-100 text-blue-800 rounded-lg px-4 py-2 flex items-center gap-2 font-medium shadow-sm transition"
            >
              <FaUserCircle size={18} />
              Profile
            </button> */}

              {/* {!location.pathname.includes("/medicine_chat") && <button
                onClick={handleMedicineInfo}
                className="bg-sky-50 hover:bg-sky-100 text-sky-800 rounded-lg px-4 py-2 flex items-center gap-2 font-medium shadow-sm transition"
              >
                <BiCapsule size={18} />
                Medicine Info

              </button>
              } */}

              {/* {!location.pathname.includes("/student-details") && (
                <button
                  onClick={handleChildDetails}
                  className="bg-green-50 hover:bg-green-100 text-green-800 rounded-lg px-4 py-2 flex items-center gap-2 font-medium shadow-sm transition"
                >
                  <FaChild size={18} />
                  Student Details
                </button>
              )} */}
            </>
          )}

        {!location.pathname.includes("/login") && (
          <div
            className="w-[40px] h-[40px] bg-gray-100 rounded-full flex justify-center items-center ml-4 cursor-pointer hover:bg-red-100 text-red-600 transition"
            onClick={logout}
            title="Logout"
          >
            <RiLogoutCircleRLine size="1.2rem" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
